import { mode } from "@chakra-ui/theme-tools";
export const buttonStyles = {
  components: {
    Button: {
      baseStyle: {
        borderRadius: "16px",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.06)",
        transition: ".2s all ease",
        boxSizing: "border-box",
        fontWeight: 600,
        _focusVisible: {
          outline: "2px solid",
          outlineColor: "brand.500",
          boxShadow: "0 0 0 2px var(--chakra-colors-brand-500) inset",
        },
        _focus: {
          outline: "2px solid",
          outlineColor: "brand.500",
        },
        _active: {
          transform: "translateY(1px)",
        },
      },
      variants: {
        outline: () => ({
          borderRadius: "16px",
        }),
        brand: (props: any) => ({
          bg: mode("brand.500", "brand.400")(props),
          color: "white",
          _focus: {
            bg: mode("brand.500", "brand.400")(props),
          },
          _active: {
            bg: mode("brand.600", "brand.400")(props),
          },
          _hover: {
            bg: mode("brand.600", "brand.400")(props),
            boxShadow: mode("0px 6px 14px rgba(45, 113, 163, 0.28)", "none")(props),
          },
        }),
        darkBrand: (props: any) => ({
          bg: mode("brand.800", "brand.400")(props),
          color: "white",
          _focus: {
            bg: mode("brand.800", "brand.400")(props),
          },
          _active: {
            bg: mode("brand.800", "brand.400")(props),
          },
          _hover: {
            bg: mode("brand.700", "brand.400")(props),
          },
        }),
        lightBrand: (props: any) => ({
          bg: mode("#F2EFFF", "whiteAlpha.100")(props),
          color: mode("brand.500", "white")(props),
          _focus: {
            bg: mode("#F2EFFF", "whiteAlpha.100")(props),
          },
          _active: {
            bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          },
          _hover: {
            bg: mode("secondaryGray.400", "whiteAlpha.200")(props),
          },
        }),
        light: (props: any) => ({
          bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          color: mode("secondaryGray.900", "white")(props),
          _focus: {
            bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          },
          _active: {
            bg: mode("secondaryGray.400", "whiteAlpha.200")(props),
          },
          _hover: {
            bg: mode("secondaryGray.400", "whiteAlpha.200")(props),
            boxShadow: mode("0px 4px 10px rgba(112, 144, 176, 0.35)", "none")(props),
          },
        }),
        action: (props: any) => ({
          fontWeight: "500",
          borderRadius: "50px",
          bg: mode("secondaryGray.300", "brand.400")(props),
          color: mode("brand.500", "white")(props),
          _focus: {
            bg: mode("secondaryGray.300", "brand.400")(props),
          },
          _active: { bg: mode("secondaryGray.300", "brand.400")(props) },
          _hover: {
            bg: mode("secondaryGray.200", "brand.400")(props),
          },
        }),
        setup: (props: any) => ({
          fontWeight: "500",
          borderRadius: "50px",
          bg: mode("transparent", "brand.400")(props),
          border: mode("1px solid", "0px solid")(props),
          borderColor: mode("secondaryGray.400", "transparent")(props),
          color: mode("secondaryGray.900", "white")(props),
          _focus: {
            bg: mode("transparent", "brand.400")(props),
          },
          _active: { bg: mode("transparent", "brand.400")(props) },
          _hover: {
            bg: mode("secondaryGray.100", "brand.400")(props),
          },
        }),
      },
    },
  },
};
